export type AppFilterChipEntry = {
  key: string;
  value?: string;
  label: string;
  removable: boolean;
};

export function orderChipsBySections(chips: AppFilterChipEntry[], sectionKeys: readonly string[]): AppFilterChipEntry[] {
  function panelPositionOf(key: string): number {
    const afterAllSections = sectionKeys.length;
    const sectionIndex = sectionKeys.indexOf(key);
    return sectionIndex === -1 ? afterAllSections : sectionIndex;
  }
  return chips.slice().sort((a, b) => {
    if (a.removable !== b.removable) return a.removable ? -1 : 1;
    return panelPositionOf(a.key) - panelPositionOf(b.key);
  });
}
